import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

interface User {
  id: number;
  name: string;
  active_flag: boolean;
}

enum Direction {
  AtoB, BtoA
}

interface Deal {
  id: number;
  title: string;
  add_time: string;
}

export default new Vuex.Store({
  state: {
    pipedriveToken: '',
    apiLoaded: false,
    urlBase: 'https://malta.pipedrive.com/v1',
    users: [],
    userA: {
      userId: '',
      deals: [],
      selectedIds: []
    },
    userB: {
      userId: '',
      deals: [],
      selectedIds: []
    },
  },
  mutations: {
    setPipedriveToken(state, token: string) {
      state.pipedriveToken = token
    },
    setUsers(state, users) {
      console.log('set users')
      state.users = users
    },
    setApiLoaded(state, val) {
      state.apiLoaded = val
    },
    setDeals(state, { side, userId, deals }) {
      console.log('setDeals commited')
      const user = side === 'userA' ? state.userA : state.userB
      user.userId = userId
      user.deals = deals
    },
    updateSelectedIds(state, { side, selectedIds }) {
      console.log('updateSelectedIds commited')
      const user = side === 'userA' ? state.userA : state.userB
      user.selectedIds = selectedIds
    },
    moveDeal(state, { moveFrom, moveTo, dealId} ) {
      console.log('commited moveDeal', moveFrom, moveTo, dealId)
      const target: Deal = moveFrom.deals.find((deal: Deal) => deal.id == dealId)
      moveTo.deals.push(target)
      moveFrom.deals = moveFrom.deals.filter(deal => deal.id != dealId)
      
      // checkedRowsも更新してしまう。本当は分けたいけど
      moveTo.selectedIds.push(dealId)
      moveFrom.selectedIds = moveFrom.selectedIds.filter(id => id != dealId)
    }
    
  },
  actions: {
    async loadUsers({state, commit}) {
      console.log('load users')
      const endpoint = `${state.urlBase}/users?api_token=${state.pipedriveToken}`
      return axios.get(endpoint)
        .then(response => {
          console.log(response)
          
          const activeUsers = response.data.data.filter((user: User) => { return user.active_flag })
          console.log(activeUsers)
          commit('setUsers', activeUsers)
          commit('setApiLoaded', true)
        })
        .catch(reason => {
          console.error(reason)
          alert(reason)
          commit('setApiLoaded', false)
        })
    },
    async loadDeals({state, commit}, {side, userId}) {
      console.log('load deals', side, userId)
      const endpoint = `${state.urlBase}/deals:(id,title,add_time,undone_activities_count)?user_id=${userId}&status=open&limit=300&api_token=${state.pipedriveToken}`
      return axios.get(endpoint)
        .then(response => {
          console.log(response)
          const deals = response.data.data != null ? response.data.data : []
          commit('setDeals', {
            side: side,
            userId: userId,
            deals: deals
          })
        })
        .catch(reason => {
          console.error(reason)
          alert(reason)
        })
    },
    async moveDeals({state, commit}, direction: Direction) {
      console.log('moveDeals')
      const moveFrom = (direction === Direction.AtoB) ? state.userA : state.userB
      const moveTo = (direction === Direction.AtoB) ? state.userB : state.userA
      console.log(moveFrom)
      for (const id of moveFrom.selectedIds) {
        console.log('id: ', id)
        // 各IDの案件をAPIで動かす処理を行い、成功したらvuex上で案件を相手サイドに追加する。その際にstoreとselectedIdsにも反映
        // 取引担当者を移行
        const dealEndpoint = `${state.urlBase}/deals/${id}?api_token=${state.pipedriveToken}`
        await axios.put(dealEndpoint, {
          user_id: moveTo.userId
        }).catch(e => {
          console.error(e)
          window.alert("取引の担当者移行に失敗しました。\n" + e)
        })

        // アクティビティ担当者を移行
        const dealActivitiesEndpoint = `${state.urlBase}/deals/${id}/activities?api_token=${state.pipedriveToken}`
        const activities = await axios.get(dealActivitiesEndpoint)

        if (activities.data.data != null) {
          activities.data.data.forEach(async activity => {
            const activityEndpoint = `${state.urlBase}/activities/${activity.id}?api_token=${state.pipedriveToken}`
            await axios.put(activityEndpoint, {
              user_id: moveTo.userId
            }).catch(e => {
              console.error(e)
              window.alert("アクティビティの担当者移行に失敗しました。\n" + e)
            })
          })
        }

        // アクティビティ移行完了したらstore上で移行
        commit('moveDeal', {
          moveFrom: moveFrom,
          moveTo: moveTo,
          dealId: id
        })
      }
      // await Promise.all(moveFrom.selectedIds.map(async id => {
        
      // }))
      
    }
  },
  getters: {
    
  },
  modules: {
  }
})
